import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: 'Sarah Johnson',
    text: '"PowerGym completely changed my life. The trainers are amazing and the community is incredibly supportive. I\'ve never felt stronger!"',
    rating: 5
  },
  {
    name: 'Mike Chen',
    text: '"The group classes are intense and fun. I\'ve lost 30 pounds and gained so much confidence. Highly recommend!"',
    rating: 5
  },
  {
    name: 'Emily Rodriguez',
    text: '"State-of-the-art equipment and clean facilities. The personal training program helped me achieve my fitness goals faster than I imagined."',
    rating: 5
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-power-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-black mb-4">What Our Members Say</h2>
          <div className="w-24 h-1 bg-power-red mx-auto"></div>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-all duration-300 group hover:-translate-y-2 relative"
            >
              <Quote className="absolute top-4 right-4 h-8 w-8 text-power-red/20" />
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed relative z-10">
                {testimonial.text}
              </p>
              <div className="font-bold text-power-red text-lg">
                - {testimonial.name}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
